// IndustryGetDto
export class Industry {
  id: number;
  name: string;
  code: string;
  emailDomain: string;
  additionalEmailDomain: string;
}
